import Button from "./Button";
import FadeUpRollover from "./FadeUpRollover";
import HeadingSmall from "./HeadingSmall";
import PropTypes from "prop-types";
import React from "react";

function UnderlineButton({ onClick, children, ...props }) {
  const textStyles = {
    color: "var(--color)",
    transition: "color 200ms",
  };

  return (
    <Button onClick={onClick} py={"5px"} {...props}>
      <FadeUpRollover>
        <HeadingSmall underline style={textStyles}>
          {children}
        </HeadingSmall>
      </FadeUpRollover>
    </Button>
  );
}

UnderlineButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default UnderlineButton;
